import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  lang: "DE",
  theme: {
    themes: {
      light: {
        primary: "#a21c26",
        secondary: "#212529",
        accent: "#a21c26",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  }
});

export default vuetify;
